import { gql } from '@apollo/client';
import { OperationMethodData } from './operation-method';

export const GET_ALL_OPERATION_METHODS = gql`
  query GetAllOperationMethods {
    OperationMethod_getAll {
      data {
        ${OperationMethodData}
      }
    }
  }
`;

export const GET_OPERATION_METHOD_BY_ID = gql`
  query GetOperationMethodById($id: String!) {
    OperationMethod_getById(id: $id) {
      ${OperationMethodData}
    }
  }
`;

export * from './operation-method';
